import React from "react";
import { ListSubheader, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useVoicesCompanyPages, useVoicesPeople } from "../../../Query/useVoicesProfiles";
import VoicesInput from "../Common/VoicesInput";

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const VoicesCalendarTargetFilter: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation("voicesPosts");
  const { data: people = [] } = useVoicesPeople();
  const { data: pages = [] } = useVoicesCompanyPages();
  const posting = people.filter((person) => person.is_posting);

  return (
    <VoicesInput
      select
      size="small"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      sx={{ width: 220 }}
    >
      <MenuItem value="">{t("posts_everyone")}</MenuItem>
      <ListSubheader>{t("targetPeople")}</ListSubheader>
      {posting.map((person) => (
        <MenuItem key={`person-${person.user_id}`} value={`person:${person.user_id}`}>
          {`${person.name} ${person.surname}`.trim()}
        </MenuItem>
      ))}
      <ListSubheader>{t("targetPages")}</ListSubheader>
      {pages.map((page) => (
        <MenuItem key={`page-${page.id}`} value={`company_page:${page.id}`}>
          {page.name}
        </MenuItem>
      ))}
    </VoicesInput>
  );
};

export default VoicesCalendarTargetFilter;
